import {
    PROFILE_ERROR, PROFILE_SUCCESS, SET_CUSTOMER_DATA, SIGNOUT_SUCCESS, SET_INSPECTION_ITEMS, SET_QUOTED_FUTURE_ITEMS
} from './../constants/constants';

const initialState = {
    title: '',
    idNumber: '',
    name: '',
    surname: '',
    dateOfBirth: '',
    email: '',
    gender: '',
    cellphoneNumber: '',
    alternateNumber: '',
    workAddress: '',
    homeAddress: '',
    maritalStatus: '',
    occupation: '',
    preferredLanguage: 'English',
    editEmail: '',
    editCellphoneNumber: '',
    editAlternateNumber: '',
    editPreferredLanguage: '',
    activePolicies: 0,
    activeLifePolicies: 0,
    lifePolicyNumber: '',
    funeralPolicyNumber: '',
    guestPolicyNumber: '',
    customerId: '',
    lifeContactId: '',
    policyId: '',
    lifePolicyId: '',
    countryId: 244, //SA: 244 - NA: 157
    currencySymbol: 'R',
    googleMapsCountryCode:'za',
    isDecreaseDonated: false,
    donationOrganizationId: '',
    isLinked: false,
    isLifeLinked: false,
    otpSent: false,
    otpToPhone: false,
    showProfile: false,
    showMobileProfile: false,
    updateEditData: false,
    personalPolicies: [],
    personalClaims: [],
    selectedPersonalClaim: '',
    selectedPersonalClaimDetails: [
        { "id": 0, "description": "overview" },
        { "id": 1, "description": "notification" },
        { "id": 2, "description": "registration" },
        { "id": 3, "description": "carhire" },
        { "id": 4, "description": "towing" },
        { "id": 5, "description": "assesment" },
        { "id": 6, "description": "processing" },
        { "id": 7, "description": "repairs" },
        { "id": 8, "description": "completed" }
    ],
    selectedPersonalClaimStep: 'overview',
    selectedPersonalPolicy: undefined,
    selectedPersonalCover: '',
    selectedPersonalQuotedCover: null,
    selectedPersonalCoverType: null,
    selectedPortablePossession: '',
    bankingDetails: [],
    inProgress: {},
    whatsNew: {},
    messages: {},
    quotes: {},
    documents: {},
    dahsboardTiles: {},
    updatePolicy: false,
    selfInspectionStep: 0,
    selectedLifeCover: null,
    broker: '',
    hasSpecialDebitDate: false,
    specialDebitDate: '',
    specialDebitAmount: 0.00,
    specialDebitDays: {},
    goToSchedule: false,
    hasScheduledSpecialDebit: false,
    scheduledSpecialDebitDate: {},
    selectedSpecialDebit: false,
    loginEmail: '',
    isEditMode: false,
    inspectionItems: [],
    quotedFutureItems: [],
}

const profileReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_CUSTOMER_DATA:
            return {
                ...state,
                email: ('email' in action.payload) ? action.payload.email : state.email,
                gender: ('gender' in action.payload) ? action.payload.gender : state.gender,
                idNumber: ('idNumber' in action.payload) ? action.payload.idNumber : state.idNumber,
                name: ('name' in action.payload) ? action.payload.name : state.name,
                surname: ('surname' in action.payload) ? action.payload.surname : state.surname,
                cellphoneNumber: ('cellphoneNumber' in action.payload) ? action.payload.cellphoneNumber : state.cellphoneNumber,
                customerId: ('customerId' in action.payload) ? action.payload.customerId : state.customerId,
                lifeContactId: ('lifeContactId' in action.payload) ? action.payload.lifeContactId : state.lifeContactId,
                policyId: ('policyId' in action.payload) ? action.payload.policyId : state.policyId,
                lifePolicyId: ('lifePolicyId' in action.payload) ? action.payload.lifePolicyId : state.lifePolicyId,
                activePolicies: ('activePolicies' in action.payload) ? action.payload.activePolicies : state.activePolicies,
                activeLifePolicies: ('activeLifePolicies' in action.payload) ? action.payload.activeLifePolicies : state.activeLifePolicies,
                countryId: ('countryId' in action.payload) ? action.payload.countryId : state.countryId,
                currencySymbol: ('currencySymbol' in action.payload) ? action.payload.currencySymbol : state.currencySymbol,
                googleMapsCountryCode: ('googleMapsCountryCode' in action.payload) ? action.payload.googleMapsCountryCode : state.googleMapsCountryCode,
                otpSent: ('otpSent' in action.payload) ? action.payload.otpSent : state.otpSent,
                otpToPhone: ('otpToPhone' in action.payload) ? action.payload.otpToPhone : state.otpToPhone,
                isLinked: ('isLinked' in action.payload) ? action.payload.isLinked : state.isLinked,
                isLifeLinked: ('isLifeLinked' in action.payload) ? action.payload.isLifeLinked : state.isLifeLinked,
                alternateNumber: ('alternateNumber' in action.payload) ? action.payload.alternateNumber : state.alternateNumber,
                workAddress: ('workAddress' in action.payload) ? action.payload.workAddress : state.workAddress,
                homeAddress: ('homeAddress' in action.payload) ? action.payload.homeAddress : state.homeAddress,
                maritalStatus: ('maritalStatus' in action.payload) ? action.payload.maritalStatus : state.maritalStatus,
                occupation: ('occupation' in action.payload) ? action.payload.occupation : state.occupation,
                preferredLanguage: ('preferredLanguage' in action.payload) ? action.payload.preferredLanguage : state.preferredLanguage,
                updateEditData: ('updateEditData' in action.payload) ? action.payload.updateEditData : state.updateEditData,
                isDecreaseDonated: ('isDecreaseDonated' in action.payload) ? action.payload.isDecreaseDonated : state.isDecreaseDonated,
                donationOrganizationId: ('donationOrganizationId' in action.payload) ? action.payload.donationOrganizationId : state.donationOrganizationId,
                showMobileProfile: ('showMobileProfile' in action.payload) ? action.payload.showMobileProfile : state.showMobileProfile,
                personalPolicies: ('personalPolicies' in action.payload) ? action.payload.personalPolicies : state.personalPolicies,
                bankingDetails: ('bankingDetails' in action.payload) ? action.payload.bankingDetails : state.bankingDetails,
                selectedPersonalCover: ('selectedPersonalCover' in action.payload) ? action.payload.selectedPersonalCover : state.selectedPersonalCover,
                selectedPersonalQuotedCover: ('selectedPersonalQuotedCover' in action.payload) ? action.payload.selectedPersonalQuotedCover : state.selectedPersonalQuotedCover,
                selectedPersonalCoverType: ('selectedPersonalCoverType' in action.payload) ? action.payload.selectedPersonalCoverType : state.selectedPersonalCoverType,
                updatePolicy: ('updatePolicy' in action.payload) ? action.payload.updatePolicy : state.updatePolicy,
                selfInspectionStep: ('selfInspectionStep' in action.payload) ? action.payload.selfInspectionStep : state.selfInspectionStep,
                selectedLifeCover: ('selectedLifeCover' in action.payload) ? action.payload.selectedLifeCover : state.selectedLifeCover,
                selectedPersonalPolicy: ('selectedPersonalPolicy' in action.payload) ? action.payload.selectedPersonalPolicy : state.selectedPersonalPolicy,
                personalClaims: ('personalClaims' in action.payload) ? action.payload.personalClaims : state.personalClaims,
                selectedPersonalClaim: ('selectedPersonalClaim' in action.payload) ? action.payload.selectedPersonalClaim : state.selectedPersonalClaim,
                selectedPersonalClaimDetails: ('selectedPersonalClaimDetails' in action.payload) ? action.payload.selectedPersonalClaimDetails : state.selectedPersonalClaimDetails,
                editEmail: ('editEmail' in action.payload) ? action.payload.editEmail : state.editEmail,
                editCellphoneNumber: ('editCellphoneNumber' in action.payload) ? action.payload.editCellphoneNumber : state.editCellphoneNumber,
                editAlternateNumber: ('editAlternateNumber' in action.payload) ? action.payload.editAlternateNumber : state.editAlternateNumber,
                editPreferredLanguage: ('editPreferredLanguage' in action.payload) ? action.payload.editPreferredLanguage : state.editPreferredLanguage,
                broker: ('broker' in action.payload) ? action.payload.broker : state.broker,
                hasSpecialDebitDate: ('hasSpecialDebitDate' in action.payload) ? action.payload.hasSpecialDebitDate : state.hasSpecialDebitDate,
                specialDebitDate: ('specialDebitDate' in action.payload) ? action.payload.specialDebitDate : state.specialDebitDate,
                specialDebitAmount: ('specialDebitAmount' in action.payload) ? action.payload.specialDebitAmount : state.specialDebitAmount,
                selectedPersonalClaimStep: ('selectedPersonalClaimStep' in action.payload) ? action.payload.selectedPersonalClaimStep : state.selectedPersonalClaimStep,
                specialDebitDays: ('specialDebitDays' in action.payload) ? action.payload.specialDebitDays : state.specialDebitDays,
                goToSchedule: ('goToSchedule' in action.payload) ? action.payload.goToSchedule : state.goToSchedule,
                hasScheduledSpecialDebit: ('hasScheduledSpecialDebit' in action.payload) ? action.payload.hasScheduledSpecialDebit : state.hasScheduledSpecialDebit,
                scheduledSpecialDebitDate: ('scheduledSpecialDebitDate' in action.payload) ? action.payload.scheduledSpecialDebitDate : state.scheduledSpecialDebitDate,
                selectedSpecialDebit: ('selectedSpecialDebit' in action.payload) ? action.payload.selectedSpecialDebit : state.selectedSpecialDebit,
                loginEmail: ('loginEmail' in action.payload) ? action.payload.loginEmail : state.loginEmail,
                selectedPortablePossession: ('selectedPortablePossession' in action.payload) ? action.payload.selectedPortablePossession : state.selectedPortablePossession,
                isEditMode: ('isEditMode' in action.payload) ? action.payload.isEditMode : state.isEditMode,
                guestPolicyNumber: ('guestPolicyNumber' in action.payload) ? action.payload.guestPolicyNumber : state.guestPolicyNumber,
            }
        case SET_INSPECTION_ITEMS:
            return {
                ...state,
                inspectionItems: action.payload
            }
        case SET_QUOTED_FUTURE_ITEMS:
            return {
                ...state,
                quotedFutureItems: action.payload
            }
        case PROFILE_SUCCESS:
            return state

        case PROFILE_ERROR:
            return state

        case SIGNOUT_SUCCESS:
            return {
                ...initialState,
            }

        default:
            return state
    }
}

export default profileReducer;